/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectPenaltyTemplateCommandResult } from '../../models/create-project-penalty-template-command-result';

export interface ApiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain$Params {
      body?: {
'Name'?: string;
'ProjectId'?: string;
}
}

export function apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectPenaltyTemplateCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectPenaltyTemplateCommandResult>;
    })
  );
}

apiProjectPenaltiesTemplateCreateProjectPenaltyTemplatePost$Plain.PATH = '/api/ProjectPenaltiesTemplate/CreateProjectPenaltyTemplate';
